import { UserCircle, Lock } from 'lucide-react';
import { CustomGpt } from '../types/custom-gpt.types';
import { ASSISTANT_ICONS } from '../constants/assistant-icons';
import { useTheme } from 'components/core/theme-provider';
import { useTranslation } from 'react-i18next';
import { useModelStore } from 'state/store/chat/use-model-store';


interface CustomGptHeaderProps {
    assistant: CustomGpt;
}

export const CustomGptHeader = ({ assistant }: CustomGptHeaderProps) => {
    const { theme } = useTheme();
    const { t } = useTranslation();
    const models = useModelStore((state) => state.models);

    const getAssistantIconSrc = (logoId?: string) => {
        if (!logoId) return undefined;
        const icon = ASSISTANT_ICONS.find(i => i.id === logoId);
        return icon?.src;
    };

    const getRecommendedModel = (modelId: string) => {
        return models.find(model => model.id === modelId);
    }

    return (
        <div className="w-full flex flex-col items-center gap-2 mb-4">
            <div className="h-8 w-8 rounded-lg overflow-hidden flex items-center justify-center shrink-0">
                {assistant.logoUrl ? (
                    <img
                        src={getAssistantIconSrc(assistant.logoUrl) || assistant.logoUrl}
                        alt={assistant.name}
                        className="h-full w-full object-cover"
                    />
                ) : (
                    <UserCircle className="h-5 w-5 text-muted-foreground" />
                )}
            </div>
            <div className="flex flex-col min-w-0 items-center">
                <h1 className={`${theme === 'dark' ? 'text-typography-white' : 'text-typography-black-primary'} text-xl font-semibold leading-[30px]`}>
                    {assistant.name}
                </h1>
                <div className={`flex items-center ${theme === 'dark' ? 'text-typography-grey-2-secondary' : 'text-typography-grey-2-secondary'} text-sm font-normal leading-[22px]`}>
                    <Lock className='h-3 w-3 mr-1' />{assistant.visibility}
                </div>
                <div className={`${theme === 'dark' ? 'text-typography-grey-2-secondary-stroke' : 'text-typography-grey-1-secondary'} text-xs font-normal leading-[18px]`}>
                    {t('RECOMMENDED_MODEL_DESCRIPTION')} {getRecommendedModel(assistant.modelName)?.name}
                </div>
            </div>
        </div>
    );
};
